/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function(){
  

    const loopUntilMmqButtonIsReady = setInterval(() => {
        const embed = document.querySelector('mmq-embed');
        const variantUI = embed?.querySelector('mmq-variant-ui');
        const canvasButtons = variantUI?.shadowRoot?.querySelector('mmq-canvas-buttons');
        const zoomAll = canvasButtons?.shadowRoot?.querySelector('mmq-zoom-all');
        const quickIcon = zoomAll?.shadowRoot?.querySelector('mmq-quick-icon-button');
        const mmqButton = quickIcon?.shadowRoot?.querySelector('mmq-button');
      
        if (!mmqButton || !mmqButton.shadowRoot) {
          return;
        }
      
        const style = document.createElement('style');
        style.textContent = `
          :host {
            --mmq-button-background: rgba(25, 25, 28, 0.20) !important;
            --mmq-button-text-color:white !important;
      
            background-color: rgba(25, 25, 28, 0.20) !important;
            color:white !important;
          }
      
          :host(:hover) {
            --mmq-button-background: rgba(25, 25, 28, 0.20) !important;
      
            background-color: rgba(25, 25, 28, 0.20) !important;
          }
        `;
      
        mmqButton.shadowRoot.appendChild(style);
        clearInterval(loopUntilMmqButtonIsReady);
      }, 50);
  
  
  
      const loopUntilNestedButtonsReady = setInterval(() => {
        const embed = document.querySelector('mmq-embed');
        const variantUI = embed?.querySelector('mmq-variant-ui');
        const canvasButtons = variantUI?.shadowRoot?.querySelector('mmq-canvas-buttons');
        const zoomButtons = canvasButtons?.shadowRoot?.querySelector('mmq-zoom-buttons');
      
        if (!zoomButtons || !zoomButtons.shadowRoot) return;
      
        const quickButtons = zoomButtons.shadowRoot.querySelectorAll('mmq-quick-icon-button');
        if (!quickButtons.length) return;
      
        let styledCount = 0;
      
        quickButtons.forEach((quickIcon, i) => {
          const mmqButton = quickIcon.shadowRoot?.querySelector('mmq-button');
          const buttonRoot = mmqButton?.shadowRoot;
      
          if (!buttonRoot) {
            // console.log(`⏳ <mmq-button> #${i + 1} not ready yet...`);
            return;
          }
      
          // Prevent duplicate styling
          if (buttonRoot.querySelector('style[data-nested-style]')) return;
      
          const style = document.createElement('style');
          style.setAttribute('data-nested-style', 'true');
          style.textContent = `
            :host {
              --mmq-button-background: rgba(25, 25, 28, 0.20) !important;
              --mmq-button-text-color: white !important;
              background-color: rgba(25, 25, 28, 0.20) !important;
              color:white !important;
            }
      
            :host(:hover) {
              --mmq-button-background: rgba(25, 25, 28, 0.20) !important;
              background-color: rgba(25, 25, 28, 0.20) !important;
            }
          `;
          buttonRoot.appendChild(style);
          styledCount++;
        });
      
        // ✅ Stop only when all buttons are styled
        if (styledCount === quickButtons.length) {
          clearInterval(loopUntilNestedButtonsReady);
          console.log(`✅ Styled ${styledCount} nested <mmq-button> elements`);
        }
      }, 100);
      
   
      // window.mimeeqApp.config.icons = {
      //   optionPanel: {
      //     plus: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 7L-2.55076e-07 7" stroke="#19191C"/> <path d="M7 0L7 14" stroke="#19191C"/> </svg>',
      //     minus: '<svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 1L-2.55076e-07 0.999999" stroke="#19191C"/> </svg>',
      //     expand: '<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18 7.74414H10.9357V0.679883" stroke="#19191C"/> <path d="M0.618164 11.4048L7.68242 11.4048L7.68242 18.469" stroke="#19191C"/> </svg>'
      //   }
      // };
  });
  
  // Initialize Mimeeq with custom Material Design icons
  window.mimeeqAppConfig = {
  icons: {
    // Quick icon toolbar icons
    quickIcons: {
      zoomAll: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"> <path d="M10.4141 13.0908C10.5865 13.0907 10.752 13.1585 10.874 13.2803C10.9961 13.4023 11.0646 13.5686 11.0645 13.7412L11.0576 20.1572C11.0572 20.5161 10.766 20.8068 10.4072 20.8066C10.0482 20.8062 9.75742 20.5152 9.75781 20.1562L9.76367 14.3906L3.99902 14.3975C3.64004 14.3979 3.34805 14.107 3.34766 13.748C3.34731 13.3892 3.63824 13.0982 3.99707 13.0977L10.4141 13.0908ZM13.5889 3.1875C13.9479 3.18789 14.2387 3.47988 14.2383 3.83887L14.2314 9.60352L19.9971 9.59766C20.3561 9.59726 20.648 9.88809 20.6484 10.2471C20.6486 10.6058 20.3578 10.8969 19.999 10.8975L13.582 10.9043C13.4094 10.9044 13.2441 10.8359 13.1221 10.7139C13 10.5918 12.9315 10.4265 12.9316 10.2539L12.9385 3.83691C12.939 3.47817 13.2301 3.1873 13.5889 3.1875Z" fill="white"/> </svg>',
    },
    misc:{
      plus: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"> <path d="M19.3633 11.2478C19.7773 11.2481 20.1133 11.5838 20.1133 11.9978C20.1133 12.4119 19.7773 12.7476 19.3633 12.7478H4.63281C4.2186 12.7478 3.88281 12.412 3.88281 11.9978C3.88281 11.5836 4.2186 11.2478 4.63281 11.2478H19.3633Z" fill="white"/> <path d="M19.3633 11.2478C19.7773 11.2481 20.1133 11.5838 20.1133 11.9978C20.1133 12.4119 19.7773 12.7476 19.3633 12.7478H4.63281C4.2186 12.7478 3.88281 12.412 3.88281 11.9978C3.88281 11.5836 4.2186 11.2478 4.63281 11.2478H19.3633Z" fill="white"/> <path d="M11.2478 19.3633V4.63281C11.2478 4.2186 11.5836 3.88281 11.9978 3.88281C12.412 3.88281 12.7478 4.2186 12.7478 4.63281V19.3633C12.7476 19.7773 12.4119 20.1133 11.9978 20.1133C11.5838 20.1133 11.2481 19.7773 11.2478 19.3633Z" fill="white"/> </svg>',
    },
    optionPanel: {
      plus: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"> <path d="M19.3633 11.2478C19.7773 11.2481 20.1133 11.5838 20.1133 11.9978C20.1133 12.4119 19.7773 12.7476 19.3633 12.7478H4.63281C4.2186 12.7478 3.88281 12.412 3.88281 11.9978C3.88281 11.5836 4.2186 11.2478 4.63281 11.2478H19.3633Z" fill="white"/> <path d="M19.3633 11.2478C19.7773 11.2481 20.1133 11.5838 20.1133 11.9978C20.1133 12.4119 19.7773 12.7476 19.3633 12.7478H4.63281C4.2186 12.7478 3.88281 12.412 3.88281 11.9978C3.88281 11.5836 4.2186 11.2478 4.63281 11.2478H19.3633Z" fill="white"/> <path d="M11.2478 19.3633V4.63281C11.2478 4.2186 11.5836 3.88281 11.9978 3.88281C12.412 3.88281 12.7478 4.2186 12.7478 4.63281V19.3633C12.7476 19.7773 12.4119 20.1133 11.9978 20.1133C11.5838 20.1133 11.2481 19.7773 11.2478 19.3633Z" fill="white"/> </svg>',
      minus: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"> <path d="M19.3633 11.25C19.7773 11.2503 20.1133 11.5859 20.1133 12C20.1133 12.4141 19.7773 12.7497 19.3633 12.75H4.63281C4.2186 12.75 3.88281 12.4142 3.88281 12C3.88281 11.5858 4.2186 11.25 4.63281 11.25H19.3633Z" fill="white"/> </svg>',
    },
  }
  }; 
  
const galleryWindow = document.getElementById('gallery-3d-window');

window.mimeeqCustomMessages = {
  'canvasside.zoomall': galleryWindow?.dataset.mimeeqZoomall || 'Center Position',
  'canvasside.zoomin': galleryWindow?.dataset.mimeeqZoomin || 'Zoom Out',
  'canvasside.zoomout': galleryWindow?.dataset.mimeeqZoomout || 'Zoom In',
};